<template>
    <div class="d-flex flex-column overflow-hidden h-100">
        <vue-custom-scrollbar
            class="app-content-padding flex-grow-1 overflow-hidden h-100"
        >
            <ts-page-title
                :title="$t('cashTransfer.pageTitle')"
                :breadcrumb="[
                    { text: $t('home'), href: '/' },
                    {
                        text: $t('cashTransfer.pageTitle'),
                        href: '/admin/cash-transfers'
                    },
                    { text: $t('create'), active: true }
                ]"
            />
            <div class="demo-spin-article">
                <ts-panel>
                    <ts-panel-wrapper>
                        <form-input
                            v-model="model"
                            :validate="errors"
                            :transfer-by-name="transferByName"
                            :currencies="currencies"
                            :banks="banks"
                        />
                    </ts-panel-wrapper>
                </ts-panel>
            </div>
        </vue-custom-scrollbar>

        <Spin size="large" fix v-if="loading"></Spin>

        <div
            id="footer"
            class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2"
            style="background-color: #e9ecef"
        >
            <ts-button
                @click.prevent="$router.push({ name: 'cash-transfer' })"
                class="btn-gray"
            >
                {{ $t("cancel") }}
            </ts-button>
            <ts-button
                color="primary"
                outline
                :waiting="waiting_new"
                :disabled="waiting_new || waiting"
                @click.prevent="onSaveAddNew"
            >
                {{ $t("saveAddNew") }}
            </ts-button>
            <ts-button
                color="primary"
                :waiting="waiting"
                :disabled="waiting_new || waiting"
                @click.prevent="onSave"
            >
                {{ $t("save") }}
            </ts-button>
        </div>
    </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import FormInput from "./components/form-input.vue";
import moment from "moment";

export default {
    name: "CashTransferCreate",
    components: { FormInput },
    data() {
        return {
            loading: false,
            waiting: false,
            waiting_new: false,
            errors: new Errors(),
            model: {
                transfer_by: null,
                transfer_date: moment(new Date()).format("DD-MM-YYYY"),
                transfer_amount: null,
                currency_id: 2,
                bank_id: null,
                bank_account_no: "",
                bank_account_name: "",
                remark: ""
            }
        };
    },
    created() {
        AppOptions.appContentFullHeight = true;
        AppOptions.appContentClass = "p-0";
    },
    computed: {
        ...mapState("finance/cashTransfer", ["currencies", "banks"]),
        transferByName() {
            const user = this.$store.state.authUser.user;
            return user && user.employee ? user.employee.employee_name_en : user.user_name;
        }
    },
    methods: {
        ...mapActions("finance/cashTransfer", ["getCurrencies", "getBanks"]),
        async fetchFormData() {
            this.loading = true;
            await this.getCurrencies();
            await this.getBanks();
            const user = this.$store.state.authUser.user;
            if (user) {
                this.model.transfer_by = user.employee_id;
            }
            this.loading = false;
        },
        async onSaveAddNew() {
            this.errors = new Errors();
            this.waiting_new = true;
            this.$store
                .dispatch("finance/cashTransfer/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    if (response.message_id == 0) this.clearInput();
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => (this.waiting_new = false));
        },
        async onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("finance/cashTransfer/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    if (response.message_id == 0) {
                        this.$router.push({ name: "cash-transfer" });
                    }
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => (this.waiting = false));
        },
        clearInput() {
            const user = this.$store.state.authUser.user;
            this.model.transfer_by = user ? user.employee_id : null;
            this.model.transfer_date = moment(new Date()).format("DD-MM-YYYY");
            this.model.transfer_amount = null;
            this.model.currency_id = 2;
            this.model.bank_id = null;
            this.model.bank_account_no = "";
            this.model.bank_account_name = "";
            this.model.remark = "";
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "CASH TRANSFER",
                desc: not.text
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => vm.fetchFormData());
    },
    beforeRouteLeave(to, from, next) {
        AppOptions.appContentFullHeight = false;
        AppOptions.appContentClass = "";
        next();
    }
};
</script>
